import { useRouter } from 'next/router';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import Market from '@/creditflowresearch/domain/Market';
import Segment from '@/creditflowresearch/domain/Segment';

export const useCurrentFilters = () => {
  const { query } = useRouter();
  const { markets, segments } = query;
  const { pageFilters, regionFilters, productFilters } = usePageFiltersContext();

  const currentRegion = regionFilters.find(({ id }) => id === pageFilters.regionIds[0]);
  const currentProduct = productFilters.find(({ id }) => id === pageFilters.productIds[0]);

  const marketIds = Market.getIds(markets);
  const segmentIds = Segment.getIds(segments);
  const currentMarket = marketIds[0] ? Market.from(marketIds[0]) : null;
  const currentSegment = segmentIds[0] ? Segment.from(segmentIds[0]) : null;

  const isCorporateContext = Boolean(markets);

  return {
    currentRegion,
    currentProduct,
    currentMarket,
    currentSegment,
    isCorporateContext,
  };
};
